import { deleteEltVersion } from 'legacy/lut/components/widgets/public/partner360/ELT'

export const deleteEltDocument = (entryId: number) => deleteEltVersion(entryId)
